<template>
  <div id="agenda-arrangement">
    <draggable v-model="arrangement" @start="drag=true" @end="drag=false" @change="onPlaceChange">
      <div v-for="piece in arrangement" :key="piece.userId" class="ui-draggable-handle draggable-user flex" :class="{'user-hidden': !piece.show}">
        <div class="icon-wrapper mr-2">
          <i class="fas fa-sort"></i>
        </div>
        {{ getUserName(piece.userId) }}
        <div class="icon-wrapper ml-auto hider pointer" @click="togglePiece(piece)">
          <i class="fas " :class="{'fa-eye': piece.show, 'fa-eye-slash': !piece.show}"></i>
        </div>
      </div>
    </draggable>
  </div>
</template>
<script>
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  created() {
    this.axios.get('/n/agenda-arrangement').then(response => {
      this.users = response.data.users
      this.arrangement = response.data.arrangement || []

      this.fillArrangementWithMissingUsers()
    })
  },
  data() {
    return {
      arrangement: [],
      users: [],
    }
  },
  methods: {
    fillArrangementWithMissingUsers() {
      const loadedUsers = this.users.filter(user => !user.hide_from_dashboard)

      // Check if all users in saved arrangement exist in loaded users
      if (this.arrangement.length > 0) {
        this.arrangement = this.arrangement.filter(piece => {
          const loadedUser = loadedUsers.find(user => user.id === piece.userId)
          if (loadedUser)
            return loadedUser
        })
      }

      const usersIdsInArrangement = this.arrangement.map(piece => piece.userId)
      let lastOrder = this.findBiggestOrder()

      // Fill users to arrangement who hasn't been added yet
      loadedUsers.forEach(user => {
        if (!usersIdsInArrangement.includes(user.id || -1))
          this.arrangement.push({
            userId: user.id,
            order: ++lastOrder,
            show: true
          })
      })
    },

    findBiggestOrder() {
      if (this.arrangement.length <= 0) {
        return -1;
      }

      let max = this.arrangement[0].order || -1
      this.arrangement.forEach(piece => {
        const pieceOrder = piece.order || -1
        if (pieceOrder > max) {
          max = pieceOrder
        }
      })

      return max;
    },

    onPlaceChange(event) {
      this.arrangement = this.arrangement.map((piece, i) => {
        piece.order = i
        return piece
      })

      this.save()
    },

    togglePiece(piece) {
      piece.show = !piece.show

      this.save()
    },

    save() {
      const data = {
        arrangement: JSON.stringify(this.arrangement)
      }

      this.axios.put('/n/agenda-arrangement', data)
        .then(res => {
          this.$awn.success('Saved!')
        })
        .catch(err => {
          //
        })
    },

    getUserName(userId) {
      const user = this.users.find(user => userId === user.id)

      if (user)
        return user.name

      return null
    }
  }
}
</script>
<style lang="scss">
#agenda-arrangement {
  .draggable-user {
    border: 1px solid black;
    margin-bottom: 8px;
    padding: 4px;
    display: flex;
    align-items: center;

    .icon-wrapper {
      display: flex;
      align-items: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/account/AgendaArrangement.vue